// import React, { useState } from 'react';
// import {
//   Box,
//   Drawer,
//   Stack,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Typography,
//   Tabs,
//   Tab,
//   Divider,
//   Collapse,
//   IconButton,
// } from '@mui/material';
// import {
//   Dashboard,
//   People,
//   Business,
//   AccessTime,
//   EventNote,
//   BookOnline,
//   Receipt,
//   HelpOutline,
//   Settings,
//   ExpandLess,
//   ExpandMore,
// } from '@mui/icons-material';
// import logo from '../assets/siera-logo.svg'

// const Sidebar = ({ open }) => {
//   const [role, setRole] = useState('admin');
//   const [myTeamOpen, setMyTeamOpen] = useState(true);

//   const handleRoleChange = (event, newRole) => {
//     setRole(newRole);
//   };

//   const adminMenuItems = [
//     { id: 'dashboard', label: 'Dashboard', icon: <Dashboard /> },
//     { id: 'my-team', label: 'My Team', icon: <People />, hasChildren: true },
//     { id: 'org-management', label: 'Org Management', icon: <Business /> },
//     { id: 'attendance', label: 'Attendance', icon: <AccessTime /> },
//     { id: 'leaves', label: 'Leaves', icon: <EventNote /> },
//     { id: 'reservations', label: 'Reservations', icon: <BookOnline /> },
//     { id: 'billing', label: 'Billing & Usage', icon: <Receipt /> },
//     { id: 'help', label: 'Help & Support', icon: <HelpOutline /> },
//     { id: 'settings', label: 'Settings', icon: <Settings /> },
//   ];

//   const employeeMenuItems = [
//     { id: 'dashboard', label: 'Dashboard', icon: <Dashboard /> },
//     { id: 'my-team', label: 'My Team', icon: <People />, hasChildren: true },
//     { id: 'attendance', label: 'Attendance', icon: <AccessTime /> },
//     { id: 'leaves', label: 'Leaves', icon: <EventNote /> },
//     { id: 'help', label: 'Help & Support', icon: <HelpOutline /> },
//     { id: 'settings', label: 'Settings', icon: <Settings /> },
//   ];

//   const menuItems = role === 'admin' ? adminMenuItems : employeeMenuItems;

//   const subItems = ['Option_01', 'Option_02', 'Option_03', 'Option_04'];

//   return (
//     <Drawer
//       variant="permanent"
//       anchor="left"
//       sx={{
//         width: 280,
//         flexShrink: 0,
//         '& .MuiDrawer-paper': {
//           width: 280,
//           boxSizing: 'border-box',
//           backgroundColor: 'background.paper',
//           borderRight: '1px solid',
//           borderColor: 'divider',
//         },
//       }}
//     >
//       <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
//         {/* Header */}
//         <Box sx={{ p: 3 }}>
//           {/* Brand */}
//           <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, mb: 4 }}>
//             <img src={logo} alt="Siera HR" style={{ width: '100px', height: 'auto' }} />
//           </Box>

//           {/* Role Toggle */}
//           <Tabs
//             value={role}
//             onChange={handleRoleChange}
//             variant="fullWidth"
//             sx={{
//               '& .MuiTabs-indicator': {
//                 display: 'none',
//               },
//               '& .MuiTabs-flexContainer': {
//                 backgroundColor: 'grey.100',
//                 borderRadius: 3,
//                 p: 0.5,
//               },
//             }}
//           >
//             <Tab
//               value="admin"
//               label="Admin"
//               sx={{
//                 borderRadius: 2,
//                 textTransform: 'none',
//                 fontWeight: 500,
//                 fontSize: '0.9rem',
//                 color: role === 'admin' ? 'primary.contrastText' : 'text.secondary',
//                 backgroundColor: role === 'admin' ? 'primary.main' : 'transparent',
//                 minHeight: 32,
//                 // '&:hover': {
//                 //   backgroundColor: role === 'admin' ? 'primary.dark' : 'grey.200',
//                 // },
//               }}
//             />
//             <Tab
//               value="employee"
//               label="Employee"
//               sx={{
//                 borderRadius: 2,
//                 textTransform: 'none',
//                 fontWeight: 500,
//                 fontSize: '0.875rem',
//                 color: role === 'employee' ? 'primary.contrastText' : 'text.secondary',
//                 backgroundColor: role === 'employee' ? 'primary.main' : 'transparent',
//                 minHeight: 32,
//                 // '&:hover': {
//                 //   backgroundColor: role === 'employee' ? 'primary.dark' : 'grey.200',
//                 // },
//               }}
//             />
//           </Tabs>
//         </Box>

//         <Divider sx={{ mx: 3 }} />

//         {/* Menu Section */}
//         <Box sx={{ flex: 1, overflow: 'auto' }}>
//           <Box sx={{ px: 3, pt: 2 }}>
//             <Typography
//               variant="caption"
//               component="div"
//               sx={{
//                 textTransform: 'uppercase',
//                 fontWeight: 600,
//                 color: 'text.secondary',
//                 fontSize: '0.75rem',
//                 letterSpacing: 0.5,
//               }}
//             >
//               Menu
//             </Typography>
//           </Box>

//           <List sx={{ px: 2, pt: 1 }}>
//             {menuItems.map((item) => (
//               <Box key={item.id}>
//                 <ListItemButton
//                   selected={item.id === 'my-team'}
//                   onClick={() => item.hasChildren && setMyTeamOpen(!myTeamOpen)}
//                   sx={{
//                     borderRadius: 2,
//                     my: 0.5,
//                     mx: 1,
//                     '&.Mui-selected': {
//                       backgroundColor: 'background.default',
//                       color: 'text.primary',
//                       '&:hover': {
//                         backgroundColor: 'primary.main',
//                       },
//                       '& .MuiListItemIcon-root': {
//                         color: 'text.primary',
//                       },
//                     },
//                     '&:hover': {
//                       backgroundColor: 'action.hover',
//                     },
//                   }}
//                 >
//                   <ListItemIcon
//                     sx={{
//                       minWidth: 40,
//                       color: 'inherit',
//                     }}
//                   >
//                     {item.icon}
//                   </ListItemIcon>
//                   <ListItemText
//                     primary={item.label}
//                     primaryTypographyProps={{
//                       fontSize: '0.9rem',
//                       fontWeight: 400,
//                     }}
//                   />
//                   {item.hasChildren && (
//                     <IconButton
//                       size="small"
//                       sx={{
//                         color: 'inherit',
//                         p: 0.5,
//                       }}
//                     >
//                       {myTeamOpen ? <ExpandLess /> : <ExpandMore />}
//                     </IconButton>
//                   )}
//                 </ListItemButton>

//                 {/* Sub-items for My Team */}
//                 {item.hasChildren && (
//                   <Collapse in={myTeamOpen} timeout="auto" unmountOnExit>
//                     <List component="div" disablePadding>
//                       {subItems.map((subItem, index) => (
//                         <ListItemButton
//                           key={index}
//                           sx={{
//                             pl: 6,
//                             ml: 3,
//                             mr: 1,
//                             borderRadius: 1.5,
//                             mb: 0.25,
//                             position: 'relative',
//                             '&::before': {
//                               content: '""',
//                               position: 'absolute',
//                               left: 18,
//                               top: '50%',
//                               transform: 'translateY(-50%)',
//                               width: 3,
//                               height: 3,
//                               borderRadius: '50%',
//                               backgroundColor: 'primary.main',
//                             },
//                             '&:hover': {
//                               backgroundColor: 'action.hover',
//                             },
//                           }}
//                         >
//                           <ListItemText
//                             primary={subItem}
//                             primaryTypographyProps={{
//                               fontSize: '0.8125rem',
//                               color: 'text.secondary',
//                             }}
//                           />
//                         </ListItemButton>
//                       ))}
//                     </List>
//                   </Collapse>
//                 )}
//               </Box>
//             ))}
//           </List>
//         </Box>
//       </Box>
//     </Drawer>
//   );
// };

// export default Sidebar;


import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  Collapse,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Dashboard,
  People,
  Business,
  AccessTime,
  EventNote,
  BookOnline,
  Receipt,
  HelpOutline,
  Settings,
  ExpandLess,
  ExpandMore,
  Groups,
  AccountBalance,
  Security,
  Assessment,
  Logout,
} from '@mui/icons-material';
import { useGetMenuStructureQuery } from '../services/dashboardApi';
import { useDispatch, useSelector } from 'react-redux';
import { logout as logoutAction } from '../store/authSlice';
import logo from '../assets/siera-logo.svg';


const SIDEBAR_WIDTH = 280;
const SIDEBAR_COLLAPSED_WIDTH = 80;

// Icon mapping moved outside for performance and clean architecture
const iconMap = {
  dashboard: <Dashboard />,
  people: <People />,
  business: <Business />,
  groups: <Groups />,
  account_balance: <AccountBalance />,
  security: <Security />,
  settings: <Settings />,
  assessment: <Assessment />,
  // Fallbacks or legacy
  Dashboard: <Dashboard />,
  People: <People />,
  Business: <Business />,
  AccessTime: <AccessTime />,
  EventNote: <EventNote />,
  BookOnline: <BookOnline />,
  Receipt: <Receipt />,
  HelpOutline: <HelpOutline />,
  Settings: <Settings />,
};

const Sidebar = ({ open, mobileOpen, isMobile, onMobileClose, onSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { data: menuData } = useGetMenuStructureQuery(undefined, {
    skip: !isAuthenticated,
  });

  const [activeItem, setActiveItem] = useState('dashboard');
  const [collapseItem, setCollapseItem] = useState('org-management');

  // logout handler – clear tokens from localStorage and reset state
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    dispatch(logoutAction());
    navigate('/login');
    if (isMobile) onMobileClose();
  };

  useEffect(() => {
    if (!open) {
      setCollapseItem('');
    }
  }, [open]);

  const transformMenu = (menuObj) => {
    return Object.entries(menuObj || {}).map(([key, item]) => {
      // Backend returns 'children' as an object with keys like 'orgStructure', 'roleAndPermission'
      const childrenObj = item.children || {};
      const children = Object.keys(childrenObj).length > 0
        ? transformMenu(childrenObj)
        : [];

      return {
        id: key,
        label: item.title,
        icon: iconMap[item.icon] || <Dashboard />,
        path: item.path,
        hasChildren: children.length > 0,
        subItems: children,
      };
    });
  };

  // Memoize menuItems to avoid extra renders and route syncing loops
  const menuItems = useMemo(() => {
    return menuData?.menu ? transformMenu(menuData.menu) : [];
  }, [menuData]);

  // Sync activeItem and collapseItem with current route pathname
  useEffect(() => {
    const currentPath = location.pathname;
    let foundActive = 'dashboard';
    let foundCollapse = '';

    menuItems.forEach((item) => {
      if (item.path && currentPath === item.path) {
        foundActive = item.id;
      }
      if (item.hasChildren && item.subItems) {
        item.subItems.forEach((sub) => {
          if (sub.path && currentPath === sub.path) {
            foundActive = item.id;
            foundCollapse = item.id;
          }
        });
      }
    });

    setActiveItem(foundActive);
    if (foundCollapse && open) {
      setCollapseItem(foundCollapse);
    }
  }, [location.pathname, menuItems, open]);

  const handleItemClick = (item) => {
    if (item.hasChildren) {
      // If sidebar is closed and item has children, open sidebar and expand
      if (!open && !isMobile && onSidebarOpen) {
        onSidebarOpen();
        // Set a timeout to allow sidebar to open before expanding
        setTimeout(() => {
          setCollapseItem(item.id);
          setActiveItem(item.id);
        }, 100);
      } else if (isMobile ? true : open) {
        setCollapseItem(collapseItem === item.id ? '' : item.id);
        setActiveItem(item.id);
      } else {
        setActiveItem(item.id);
      }
    } else if (item.path) {
      setActiveItem(item.id);
      navigate(item.path);
      if (isMobile) {
        onMobileClose();
      }
    } else if (!item.hasChildren) {
      setActiveItem(item.id);
      if (isMobile) {
        onMobileClose();
      }
    }
  };

  const handleSubItemClick = (subItem) => {
    if (subItem.path) {
      navigate(subItem.path);
      if (isMobile) {
        onMobileClose();
      }
    }
  };

  const getExpandIcon = (itemId) => {
    return collapseItem === itemId ? <ExpandLess /> : <ExpandMore />;
  };

  const isSubMenuOpen = (itemId) => {
    return collapseItem === itemId;
  };

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={isMobile ? mobileOpen : true}
      onClose={onMobileClose}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        width: isMobile ? SIDEBAR_WIDTH : (open ? SIDEBAR_WIDTH : SIDEBAR_COLLAPSED_WIDTH),
        transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '& .MuiDrawer-paper': {
          width: isMobile ? SIDEBAR_WIDTH : (open ? SIDEBAR_WIDTH : SIDEBAR_COLLAPSED_WIDTH),
          transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          overflowX: 'hidden',
          boxSizing: 'border-box',
          backgroundColor: '#FFFFFF',
          borderRight: '1px solid rgba(117, 34, 209, 0.08)',
          boxShadow: (isMobile || open) ? '4px 0 24px rgba(117, 34, 209, 0.02)' : 'none',
          ...(isMobile && {
            position: 'fixed',
            zIndex: 1200,
          }),
        },
      }}
    >
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#FFFFFF' }}>
        {/* HEADER */}
        <Box sx={{ p: (isMobile || open) ? 3 : 2, transition: 'padding 0.3s ease' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: (isMobile || open) ? 3 : 2, transition: 'margin 0.3s ease' }}>
            <img
              src={logo}
              alt="Siera HR"
              style={{
                width: (isMobile ? true : open) ? 100 : 40,
                transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          </Box>
        </Box>

        <Divider sx={{ mx: 3, mb: 1, borderColor: 'rgba(117, 34, 209, 0.08)' }} />

        {/* MENU */}
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            '&::-webkit-scrollbar': {
              width: '5px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(117, 34, 209, 0.12)',
              borderRadius: '10px',
              '&:hover': {
                backgroundColor: 'rgba(117, 34, 209, 0.24)',
              },
            }
          }}
        >
          {(isMobile ? true : open) && (
            <Typography
              sx={{
                px: 3,
                pt: 2,
                pb: 1,
                textTransform: 'uppercase',
                fontWeight: 600,
                color: 'text.secondary',
                fontSize: '0.7rem',
                letterSpacing: 1,
                fontFamily: '"Outfit", "Inter", sans-serif',
              }}
              variant="caption"
            >
              MENU
            </Typography>
          )}

          <List sx={{ px: 1 }}>
            {menuItems.map((item) => (
              <Box key={item.id}>
                <Tooltip
                  title={item.label}
                  placement="right"
                  disableHoverListener={isMobile || open}
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: '#7522D1',
                        color: '#FFFFFF',
                        fontWeight: 600,
                        fontSize: '0.8rem',
                        boxShadow: '0 4px 12px rgba(117, 34, 209, 0.15)',
                        '& .MuiTooltip-arrow': {
                          color: '#7522D1',
                        },
                      },
                    },
                  }}
                >
                  <ListItemButton
                    selected={activeItem === item.id}
                    onClick={() => handleItemClick(item)}
                    sx={{
                      borderRadius: '10px',
                      my: 0.4,
                      mx: (isMobile || open) ? 1.5 : 1,
                      py: 1.2,
                      justifyContent: (isMobile ? true : open) ? 'flex-start' : 'center',
                      position: 'relative',
                      transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(117, 34, 209, 0.08)',
                        color: '#7522D1',
                        '&:hover': {
                          backgroundColor: 'rgba(117, 34, 209, 0.12)',
                        },
                        '& .MuiListItemIcon-root': {
                          color: '#7522D1',
                        },
                        '&::before': (isMobile || open) ? {
                          content: '""',
                          position: 'absolute',
                          left: 0,
                          top: '20%',
                          bottom: '20%',
                          width: '3.5px',
                          borderRadius: '0 4px 4px 0',
                          backgroundColor: '#7522D1',
                        } : {},
                      },
                      '&:hover': {
                        backgroundColor: 'rgba(117, 34, 209, 0.04)',
                        transform: (isMobile || open) ? 'translateX(4px)' : 'scale(1.08)',
                        color: '#7522D1',
                        '& .MuiListItemIcon-root': {
                          color: '#7522D1',
                        },
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: (isMobile ? true : open) ? 2 : 0,
                        justifyContent: 'center',
                        color: activeItem === item.id ? '#7522D1' : 'rgba(79, 73, 55, 0.7)',
                        transition: 'color 0.2s',
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>

                    <ListItemText
                      primary={item.label}
                      sx={{
                        color: 'inherit',
                        opacity: (isMobile ? true : open) ? 1 : 0,
                        transition: 'opacity 0.2s',
                        whiteSpace: 'nowrap',
                      }}
                      primaryTypographyProps={{
                        fontSize: '0.875rem',
                        fontWeight: activeItem === item.id ? 600 : 500,
                        fontFamily: '"Outfit", "Inter", sans-serif',
                        letterSpacing: '0.1px',
                      }}
                    />

                    {(isMobile ? true : open) && item.hasChildren && (
                      <IconButton
                        size="small"
                        sx={{
                          color: 'inherit',
                          p: 0.5,
                          ml: 'auto',
                        }}
                      >
                        {getExpandIcon(item.id)}
                      </IconButton>
                    )}
                  </ListItemButton>
                </Tooltip>

                {/* Sub-items */}
                {(isMobile ? true : open) && item.hasChildren && item.subItems && (
                  <Collapse in={isSubMenuOpen(item.id)} timeout="auto" unmountOnExit>
                    <List
                      disablePadding
                      sx={{
                        position: 'relative',
                        pl: 2,
                        ml: 4.5, // Aligns vertical line with parent icon center
                        borderLeft: '1.5px solid rgba(117, 34, 209, 0.12)',
                        my: 0.5,
                      }}
                    >
                      {item.subItems.map((sub, i) => {
                        const isSubActive = window.location.pathname === sub.path;
                        return (
                          <ListItemButton
                            key={i}
                            sx={{
                              pl: 2,
                              py: 0.6,
                              pr: 1,
                              borderRadius: '8px',
                              mb: 0.4,
                              position: 'relative',
                              transition: 'all 0.2s ease',
                              color: isSubActive ? '#7522D1' : 'text.secondary',
                              backgroundColor: isSubActive ? 'rgba(117, 34, 209, 0.04)' : 'transparent',
                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                left: -17.5, // Centers dot right on the line
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                backgroundColor: isSubActive ? '#7522D1' : 'rgba(117, 34, 209, 0.3)',
                                boxShadow: isSubActive ? '0 0 6px rgba(117, 34, 209, 0.5)' : 'none',
                                transition: 'all 0.2s ease',
                              },
                              '&:hover': {
                                backgroundColor: 'rgba(117, 34, 209, 0.06)',
                                color: '#7522D1',
                                '&::before': {
                                  backgroundColor: '#7522D1',
                                  transform: 'translateY(-50%) scale(1.3)',
                                  boxShadow: '0 0 8px rgba(117, 34, 209, 0.6)',
                                },
                              },
                            }}
                            onClick={() => handleSubItemClick(sub)}
                          >
                            <ListItemText
                              primary={typeof sub === 'string' ? sub : sub.label}
                              primaryTypographyProps={{
                                fontSize: '0.8125rem',
                                fontWeight: isSubActive ? 600 : 400,
                                fontFamily: '"Outfit", "Inter", sans-serif',
                              }}
                            />
                          </ListItemButton>
                        );
                      })}
                    </List>
                  </Collapse>
                )}
              </Box>
            ))}
          </List>
        </Box>

        {/* logout button fixed at bottom */}
        <Box sx={{ p: 1.5, borderTop: '1px solid rgba(117, 34, 209, 0.08)' }}>
          <Tooltip
            title="Logout"
            placement="right"
            disableHoverListener={isMobile || open}
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: '#D32F2F',
                  color: '#FFFFFF',
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  boxShadow: '0 4px 12px rgba(211, 47, 47, 0.15)',
                  '& .MuiTooltip-arrow': {
                    color: '#D32F2F',
                  },
                },
              },
            }}
          >
            <ListItemButton
              onClick={handleLogout}
              sx={{
                borderRadius: '10px',
                mx: (isMobile || open) ? 1.5 : 1,
                py: 1.2,
                justifyContent: (isMobile ? true : open) ? 'flex-start' : 'center',
                transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                color: 'text.secondary',
                '&:hover': {
                  backgroundColor: 'rgba(211, 47, 47, 0.06)',
                  color: '#D32F2F',
                  transform: (isMobile || open) ? 'translateX(4px)' : 'scale(1.08)',
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: (isMobile ? true : open) ? 2 : 0,
                  justifyContent: 'center',
                  color: 'inherit',
                  transition: 'color 0.25s',
                }}
              >
                <Logout />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                sx={{
                  opacity: (isMobile ? true : open) ? 1 : 0,
                  transition: 'opacity 0.2s',
                  color: 'inherit',
                }}
                primaryTypographyProps={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  fontFamily: '"Outfit", "Inter", sans-serif',
                }}
              />
            </ListItemButton>
          </Tooltip>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar;